// src/context/LikesContext.js

import { createContext } from "react";

const LikesContext = createContext();

export default LikesContext;
